module.exports = __webpack_public_path__ + "img/winerackdog09.e998230f.jpg";